module.exports = __webpack_public_path__ + "img/neighbors.svg";